import { render, staticRenderFns } from "./NativeAdListBuyboxOffer.vue?vue&type=template&id=13c531b6&scoped=true"
import script from "./NativeAdListBuyboxOffer.vue?vue&type=script&setup=true&lang=ts"
export * from "./NativeAdListBuyboxOffer.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./NativeAdListBuyboxOffer.vue?vue&type=style&index=0&id=13c531b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c531b6",
  null
  
)

export default component.exports